/**
 * Web Storage toolkit for key name and limit enforcement
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
export { getItem, setItem, removeItem, generateKeyName, artificialByteLimit } from './web-storage.js';
registerLibrary({
    name: '@onviobr/web-storage',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "3.1.0",
});
